
  import React from "react"
  import Component from "/Users/ntaylor/Workspace/nate-site/src/layouts/index.js"
  import data from "/Users/ntaylor/Workspace/nate-site/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js